import { render, staticRenderFns } from "./cxHistList.vue?vue&type=template&id=3671c08c&scoped=true"
import script from "./cxHistList.vue?vue&type=script&lang=js"
export * from "./cxHistList.vue?vue&type=script&lang=js"
import style0 from "./cxHistList.vue?vue&type=style&index=0&id=3671c08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671c08c",
  null
  
)

export default component.exports